(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AssociateApplication',
	};

	// Debounce timer to prevent excessive API calls
	var emailLookupTimer = null;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var $firstName,
		    $lastName,
		    $nickname,
		    requirePayment;

		// Check if payment is required by checking if payment information box exists
		requirePayment = $form.find('#associateapplication-credit_card_number').length > 0;

		$form.find('#copy-address').change(function copyAddress() {
			var $self = $(this);

			if ($self.is(':checked')) {
				$('#associateapplication-credit_card_address1').val($('#associateapplication-address1').val());
				$('#associateapplication-credit_card_address2').val($('#associateapplication-address2').val());
				$('#associateapplication-credit_card_city').val($('#associateapplication-city').val());
				$('#associateapplication-credit_card_state_id').val($('#associateapplication-state_id').val());
				$('#associateapplication-credit_card_zip').val($('#associateapplication-zip').val());
			}
		});

		// Add event listeners for name fields to update email options
		$firstName = $('#associateapplication-first_name');
		$lastName  = $('#associateapplication-last_name');
		$nickname  = $('#associateapplication-nickname');

		// Bind change events to all three fields
		$firstName.on('blur', function onFirstNameBlur() {
			updateEmailOptions();
		});

		$lastName.on('blur', function onLastNameBlur() {
			updateEmailOptions();
		});

		$nickname.on('blur', function onNicknameBlur() {
			updateEmailOptions();
		});

		// Also trigger on keyup with debouncing for better UX
		$firstName.on('keyup', function onFirstNameKeyup() {
			debounceEmailLookup();
		});

		$lastName.on('keyup', function onLastNameKeyup() {
			debounceEmailLookup();
		});

	$nickname.on('keyup', function onNicknameKeyup() {
		debounceEmailLookup();
	});

	// Add confirmation popup before form submission if payment is required
	if (requirePayment) {
		form.confirm_before_submit = true;
		form.confirm_message = 'Please confirm your payment details. Ensure your credit card number, expiration date, CVV, and billing address match exactly what appears on your card to avoid processing delays. Would you like to continue with submitting your application?';
	}
};

	/**
	 * Debounce the email lookup to prevent excessive API calls while typing
	 */
	function debounceEmailLookup() {
		// Clear existing timer
		if (emailLookupTimer) {
			clearTimeout(emailLookupTimer);
		}

		// Set new timer to trigger lookup after 500ms of no typing
		emailLookupTimer = setTimeout(function triggerEmailLookup() {
			updateEmailOptions();
		}, 500);
	}

	/**
	 * Fetch available email addresses from the server and update the dropdown
	 */
	function updateEmailOptions() {
		var firstName,
		    lastName,
		    nickname,
		    $cpEmailSelect,
		    url;

		firstName      = $('#associateapplication-first_name').val().trim();
		lastName       = $('#associateapplication-last_name').val().trim();
		nickname       = $('#associateapplication-nickname').val().trim();
		$cpEmailSelect = $('#associateapplication-cp_email');

		// Only proceed if we have at least first and last name
		if (!firstName || !lastName) {
			return;
		}

		// Minimum length check to avoid unnecessary lookups
		if (firstName.length < 2 || lastName.length < 2) {
			return;
		}

		// Show loading state
		$cpEmailSelect.prop('disabled', true);
		$cpEmailSelect.empty();
		$cpEmailSelect.append($('<option>').text('Loading available emails...').attr('value', ''));

		// Build URL with parameters as path segments (framework style)
		url = '/Franchises/getAvailableEmailAddresses/' + encodeURIComponent(firstName)
		    + '/' + encodeURIComponent(lastName);
		
		if (nickname) {
			url += '/' + encodeURIComponent(nickname);
		}

		// Make AJAX request to get available emails
		Adzuki.Ajax.get(url)
		.then(function populateEmailDropdown(response) {
			// Clear the dropdown
			$cpEmailSelect.empty();

			if (response.success && response.emails && Object.keys(response.emails).length > 0) {
				// Populate dropdown with available emails
				$.each(response.emails, function addEmailOption(key, value) {
					$cpEmailSelect.append($('<option>').text(value).attr('value', key));
				});

				// Select the first option by default
				$cpEmailSelect.val(Object.keys(response.emails)[0]);
			} else {
				// No emails available
				$cpEmailSelect.append($('<option>').text('No available email addresses found').attr('value', ''));
			}

			// Re-enable the dropdown
			$cpEmailSelect.prop('disabled', false);
		})
		.fail(function handleEmailError(error) {
			// Handle error
			console.error('Error fetching email addresses:', error);
			
			$cpEmailSelect.empty();
			$cpEmailSelect.append($('<option>').text('Error loading emails. Please try again.').attr('value', ''));
			$cpEmailSelect.prop('disabled', false);
		});
	}
}(jQuery, window.Adzuki || {}));
